import Vue from 'vue'
import Vuex from 'vuex'

// 引入根级别配置
// import state from './state'
// import getters from './getters'
// import mutations from './mutations'
// import actions from './actions'

// 引入模块
// import user from './modules/user'
import search from './modules/search'

Vue.use(Vuex)

export default new Vuex.Store({
  // 根级别状态
  // state,
  // getters,
  // mutations,
  // actions,
  
  // 模块注册
  modules: {
    // user,      // 用户模块：state.user.xxx
    search     // 搜索模块：state.search.xxx
  },
  
  // 严格模式（开发环境建议开启）
  strict: process.env.NODE_ENV !== 'production'
})